import LessonCard from './LessonCard';

export default LessonCard;
